/**
 * Torn's personal stat names (v1, all one word) → readable labels and groups. Anything not
 * listed still shows, under its own name, in "Other".
 */
export const PS_LABELS: Record<string, string> = {
  useractivity: 'Time played (seconds)',
  activestreak: 'Activity streak (days)',
  bestactivestreak: 'Best activity streak',
  networth: 'Networth (Torn’s daily figure)',
  attackswon: 'Attacks won',
  attackslost: 'Attacks lost',
  attacksdraw: 'Attacks drawn',
  attacksassisted: 'Assists',
  attackhits: 'Hits',
  attackmisses: 'Misses',
  attackdamage: 'Total damage',
  attackcriticalhits: 'Critical hits',
  attacksstealthed: 'Stealthed attacks',
  attacksrun: 'Attacks escaped',
  defendswon: 'Defends won',
  defendslost: 'Defends lost',
  defendsstalemated: 'Defends stalemated',
  bestdamage: 'Best damage',
  bestkillstreak: 'Best kill streak',
  killstreak: 'Kill streak',
  onehitkills: 'One-hit kills',
  respectforfaction: 'Respect earned',
  rankedwarhits: 'Ranked war hits',
  rankedwarringwins: 'Ranked war wins',
  raidhits: 'Raid hits',
  territoryjoins: 'Territory joins',
  retals: 'Retaliations',
  elo: 'Elo rating',
  yourunaway: 'Times you ran away',
  theyrunaway: 'Times they ran away',
  unarmoredwon: 'Unarmored wins',
  largestmug: 'Largest mug',
  moneymugged: 'Money mugged',
  arrestsmade: 'Arrests made',
  highestbeaten: 'Highest level beaten',
  bountiescollected: 'Bounties collected',
  totalbountyreward: 'Bounty rewards',
  bountiesplaced: 'Bounties placed',
  bountiesreceived: 'Bounties received',
  totalbountyspent: 'Spent on bounties',
  revives: 'Revives given',
  revivesreceived: 'Revives received',
  reviveskill: 'Revive skill',
  hospital: 'Times hospitalized',
  medicalitemsused: 'Medical items used',
  bloodwithdrawn: 'Blood bags filled',
  jailed: 'Times jailed',
  peoplebusted: 'People busted',
  failedbusts: 'Failed busts',
  peoplebought: 'Bail paid (people)',
  peopleboughtspent: 'Bail paid',
  criminaloffenses: 'Crimes (total)',
  vandalism: 'Vandalism',
  theft: 'Theft',
  counterfeiting: 'Counterfeiting',
  fraud: 'Fraud',
  illicitservices: 'Illicit services',
  cybercrime: 'Cybercrime',
  extortion: 'Extortion',
  illegalproduction: 'Illegal production',
  organisedcrimes: 'Organised crimes',
  xantaken: 'Xanax taken',
  exttaken: 'Ecstasy taken',
  lsdtaken: 'LSD taken',
  opitaken: 'Opium taken',
  shrtaken: 'Shrooms taken',
  spetaken: 'Speed taken',
  pcptaken: 'PCP taken',
  kettaken: 'Ketamine taken',
  vicodin: 'Vicodin taken',
  victaken: 'Vicodin taken',
  cantaken: 'Cannabis taken',
  drugsused: 'Drugs used',
  overdosed: 'Overdoses',
  rehabs: 'Rehabs',
  rehabcost: 'Spent on rehab',
  refills: 'Energy refills',
  nerverefills: 'Nerve refills',
  tokenrefills: 'Token refills',
  energydrinkused: 'Energy drinks used',
  alcoholused: 'Alcohol used',
  candyused: 'Candy used',
  boostersused: 'Boosters used',
  statenhancersused: 'Stat enhancers used',
  itemsbought: 'Items bought',
  itemsboughtabroad: 'Items bought abroad',
  itemssent: 'Items sent',
  itemsdumped: 'Items dumped',
  itemslooted: 'Items looted',
  trashfound: 'Trash found',
  dumpsearches: 'Dump searches',
  booksread: 'Books read',
  traveltimes: 'Times travelled',
  traveltime: 'Time in the air (seconds)',
  timespenttraveling: 'Time in the air (seconds)',
  argtravel: 'Trips to Argentina',
  mextravel: 'Trips to Mexico',
  dubtravel: 'Trips to the UAE',
  hawtravel: 'Trips to Hawaii',
  japtravel: 'Trips to Japan',
  lontravel: 'Trips to the UK',
  soutravel: 'Trips to South Africa',
  switravel: 'Trips to Switzerland',
  chitravel: 'Trips to China',
  cantravel: 'Trips to Canada',
  caytravel: 'Trips to the Caymans',
  attackswonabroad: 'Attacks won abroad',
  defendslostabroad: 'Defends lost abroad',
  huntingskill: 'Hunting skill',
  racingskill: 'Racing skill',
  racingpointsearned: 'Racing points',
  raceswon: 'Races won',
  racesentered: 'Races entered',
  missionscompleted: 'Missions completed',
  contractscompleted: 'Contracts completed',
  dukecontractscompleted: 'Duke contracts',
  missioncreditsearned: 'Mission credits',
  auctionswon: 'Auctions won',
  auctionsells: 'Auction sales',
  pointsbought: 'Points bought',
  pointssold: 'Points sold',
  stockpayouts: 'Stock payouts',
  stockprofits: 'Stock profits',
  stocklosses: 'Stock losses',
  stocknetprofits: 'Stock net profit',
  stockfees: 'Stock fees',
  cityfinds: 'City finds',
  weaponsbought: 'Weapons bought',
  bazaarcustomers: 'Bazaar customers',
  bazaarsales: 'Bazaar sales',
  bazaarprofit: 'Bazaar profit',
  jobpointsused: 'Job points used',
  trainsreceived: 'Company trains received',
  daysbeendonator: 'Days as donator',
  personalsplaced: 'Personals placed',
  classifiedadsplaced: 'Classified ads',
  mailssent: 'Mails sent',
  friendmailssent: 'Mails to friends',
  factionmailssent: 'Mails to faction',
  companymailssent: 'Mails to company',
  spousemailssent: 'Mails to spouse',
  logins: 'Logins',
  awards: 'Awards',
  meritsbought: 'Merits used',
  virusescoded: 'Viruses coded',
  cityitemsbought: 'City items bought',
  nerverefill: 'Nerve refills',
  networthpending: 'Networth: pending',
  timesrespected: 'Respect gains',
  specialammoused: 'Special ammo used',
  hollowammoused: 'Hollow point ammo',
  tracerammoused: 'Tracer ammo',
  piercingammoused: 'Piercing ammo',
  incendiaryammoused: 'Incendiary ammo',
  roundsfired: 'Rounds fired',
  heahits: 'Heavy artillery hits',
  machits: 'Machine gun hits',
  rifhits: 'Rifle hits',
  smghits: 'SMG hits',
  shohits: 'Shotgun hits',
  pishits: 'Pistol hits',
  grehits: 'Temporary weapon hits',
  axehits: 'Clubbing hits',
  pihits: 'Piercing hits',
  slahits: 'Slashing hits',
  h2hhits: 'Hand-to-hand hits',
  chahits: 'Mechanical hits',
};

const GROUPS: Array<[string, RegExp]> = [
  ['Attacking', /attack|defend|damage|kill|hit|respect|ranked|raid|territory|retal|elo|runaway|mug|highestbeaten|unarmored|stealth|ammo|rounds|bount|arrest|critical/],
  ['Crimes & jail', /crime|offens|vandal|theft|counterfeit|fraud|illicit|cyber|extortion|illegal|jail|bust|bought(spent)?$|peoplebought|virus/],
  ['Medical', /revive|hospital|medical|blood/],
  ['Drugs & boosters', /taken|drug|overdos|rehab|refill|energydrink|alcohol|candy|booster|enhancer|vicodin/],
  ['Travel', /travel|abroad/],
  ['Items & trading', /item|trash|dump|book|auction|point|bazaar|stock|weapon|cityfind/],
  ['Racing & skills', /rac|hunting|skill|mission|contract/],
  ['Activity', /activ|login|award|merit|donator|mail|personal|classified|networth|job|train/],
];

export function psGroup(key: string): string {
  return GROUPS.find(([, re]) => re.test(key))?.[0] ?? 'Other';
}

export function psLabel(key: string): string {
  return PS_LABELS[key] ?? key.replace(/_/g, ' ');
}

/** The stats shown first, and compared through Torn's own history when there's no Omni-Torn history yet (Torn takes 10 at a time). */
export const KEY_STATS = ['xantaken', 'refills', 'nerverefills', 'energydrinkused', 'boostersused', 'attackswon', 'defendswon', 'respectforfaction', 'criminaloffenses', 'useractivity'] as const;

/** Stats counted in seconds (shown as hours). */
export const SECONDS_STATS = new Set(['useractivity', 'traveltime', 'timespenttraveling']);
